import { ComponentsSlideSelectorF } from '../../../../../../modules/Components/SlideSelector/F/Function/module/ComponentsSlideSelectorF.js';

// ComponentsHeaderF.init();

ComponentsSlideSelectorF.init();

// if ($qs('.bottom-tab-bar')) {
//   ComponentsBottomTabBarF.init();
// }
